import { AbstractEntityEditor } from "../edit"; 
import { IStructuredPage } from "./IStructuredDocument";
import { IObjectEditable } from "./IObjectEditable";

export abstract class AbstractObjectEditor<TPage extends IStructuredPage<TObjectBase>, TObjectBase, TObject extends TObjectBase> extends AbstractEntityEditor<TPage, TObjectBase, TObject> implements IObjectEditable {
  constructor(source: TObject | AbstractObjectEditor<TPage, TObjectBase, TObject>, isNew: boolean = false) {
    super(source, isNew);
    this._isSelected = ((source instanceof AbstractObjectEditor) && source._isSelected)
      || isNew;
  }

  private _isSelected: boolean;

  isSelected(): boolean {
    return this._isSelected;
  }

  select(): void {
    this._isSelected = true;
  }

  deselect(): void {
    this._isSelected = false;
  }
}
